import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Upload-Square--Streamline-Flex"
    >
        <desc>{'Upload Square Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="upload-square--arrow-download-internet-network-server-square-up-upload">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.34375 6.34583c-0.46876 -0.93753 -1.40629 -1.87505 -2.34378 -2.34382 -0.93756 0.46877 -1.87508 1.40629 -2.34385 2.34382"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m7 9.99799 0 -5.97032"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.96 3.732c0.07941 -0.70347 0.39481 -1.35929 0.89476 -1.86051C2.35472 1.37026 3.00973 1.0532 3.713 0.972 4.783 0.852 5.88 0.75 7 0.75s2.218 0.102 3.287 0.222c0.7033 0.0812 1.3583 0.39826 1.8582 0.89949 0.5 0.50122 0.8154 1.15704 0.8948 1.86051 0.114 1.063 0.21 2.155 0.21 3.268s-0.096 2.205 -0.21 3.269c-0.0794 0.7035 -0.3948 1.3593 -0.8948 1.8605 -0.4999 0.5012 -1.1549 0.8183 -1.8582 0.8995 -1.07 0.118 -2.167 0.221 -3.287 0.221s-2.218 -0.102 -3.287 -0.222c-0.70327 -0.0812 -1.35828 -0.3983 -1.85824 -0.8995 -0.49995 -0.5012 -0.81535 -1.157 -0.89476 -1.8605C0.846 9.206 0.75 8.114 0.75 7c0 -1.114 0.096 -2.205 0.21 -3.268Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
